import React from 'react'
import { Primary, Secondary } from './styles'

const variants = {
  primary: Primary,
  secondary: Secondary,
}

const ButtonComponent = ({ variant = 'primary', label, ...props }) => {
  const Button = variants[variant]
  return <Button {...props}>{label}</Button>
}

export default ButtonComponent
